import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { SuppliesModel } from '../models/SuppliesModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class SuppliesService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getsupplies(supCode: string , comCode: string) {
      let params = new HttpParams();
        params = params.append("supCode", supCode);
        params = params.append("compCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<SuppliesModel>(this.urlsconfig.WebAPIURL_Test + 'api/Supplies/GetSupplies',options);
    }
    public Addsupplies(supplies: SuppliesModel) {
        return this.http.post<SuppliesModel>(this.urlsconfig.WebAPIURL_Test + 'api/Supplies/AddSupplies', supplies);
    }

    public delSupplies(supCode: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("supCode", supCode);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<SuppliesModel>(this.urlsconfig.WebAPIURL_Test + 'api/Supplies/Deletesupplies',options);
    }
    public getSuppliesLookup(supCode: string, supName: string, compCode: string) {
      let params = new HttpParams();
      params = params.append("supCode", supCode);
      params = params.append("supName", supName);
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<SuppliesModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Supplies/SuppliesLookup', options);
  }

  public getSuppliesLookupTop(compCode: string) {
    let params = new HttpParams();
    params = params.append("compCode", compCode);
    const options = {
        params: params
    };
    return this.http.get<SuppliesModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Supplies/SuppliesLookupTop', options);
}

}
